export default __webpack_public_path__ + "static/media/pattern-dots.dba411dc.svg";